/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Moduł
 * @example "RENT_FLAT"
 */
export enum Module {
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_PLOT = "RENT_PLOT",
  RENT_OTHER = "RENT_OTHER",
}

export interface OpinionUpdateInformation {
  /**
   * Id opinii
   * @format int64
   * @example 1
   */
  opinionId: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
}

/**
 * Id lokalizacji
 * @example [{"id":15},{"id":25}]
 */
export interface LocationDto {
  /** @format int32 */
  id?: number;
  fullName?: string;
}

/** Oferta od */
export enum OfferFromEnum {
  OsobaPrywatna = "Osoba prywatna",
  Agencja = "Agencja",
}

/**
 * Id lokalizacji OSM
 * Lokalizacja OSM
 * @example [{"id":15},{"id":25}]
 */
export interface OsmLocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

/** Typ działki */
export enum PlotBuildingTypeEnum {
  Budowlana = "Budowlana",
  Rolna = "Rolna",
  Lesna = "Leśna",
  Pozostale = "Pozostałe",
}

export interface PlotsFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od, Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do, Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  lowerOriginalPrice: boolean;
  unlockedAdvertisements: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Typ ogłoszeniodawcy
   * Wybór wielu opcji
   * @example ["Agencja"]
   */
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Typ budynku
   * Wybór wielu opcji
   * @example ["Budowlana"]
   */
  buildingType?: PlotBuildingTypeEnum[];
}

export enum SortType {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
  PRICE_DESC = "PRICE_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_PER_SQUARE_METER_ASC = "PRICE_PER_SQUARE_METER_ASC",
  PRICE_PER_SQUARE_METER_DESC = "PRICE_PER_SQUARE_METER_DESC",
  MODIFICATION_DATE = "MODIFICATION_DATE",
  SCORE_ASC = "SCORE_ASC",
  SCORE_DESC = "SCORE_DESC",
}

/** Typ budynku */
export enum OtherBuildingTypeEnum {
  Garaze = "Garaże",
  Hale = "Hale",
  Pozostale = "Pozostałe",
}

export interface OtherFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od, Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do, Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  lowerOriginalPrice: boolean;
  unlockedAdvertisements: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Typ ogłoszeniodawcy
   * Wybór wielu opcji
   * @example ["Agencja"]
   */
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Piętro od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Liczba pięter od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Liczba pięter do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
  /**
   * Liczba pokoi od
   * @format int32
   * @example 4
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi do
   * @format int32
   * @example 4
   */
  numberOfRoomsTo?: number;
  /**
   * Typ rynku nieruchomości
   * Wybór wielu opcji
   * @example ["Pierwotny"]
   */
  typeOfMarket?: TypeOfMarketEnum[];
  /**
   * Typ budynku
   * Wybór wielu opcji
   * @example ["Garaże"]
   */
  buildingType?: OtherFilterDtoBuildingTypeEnum;
}

/** Market */
export enum TypeOfMarketEnum {
  Pierwotny = "Pierwotny",
  Wtorny = "Wtórny",
}

/**
 * Typ budynku
 * @example "Blok"
 */
export enum HouseBuildingTypeEnum {
  Wolnostojacy = "Wolnostojący",
  Blizniak = "Bliźniak",
  Szeregowy = "Szeregowy",
  Pozostale = "Pozostałe",
}

export interface HousesFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od, Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do, Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  lowerOriginalPrice: boolean;
  unlockedAdvertisements: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Typ ogłoszeniodawcy
   * Wybór wielu opcji
   * @example ["Agencja"]
   */
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Liczba pokoi w domu od
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w domu do
   * @format int32
   * @min 0
   * @example 5
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Typ rynku nieruchomości
   * Wybór wielu opcji
   * @example ["Pierwotny"]
   */
  typeOfMarket?: TypeOfMarketEnum[];
  /**
   * Typ budynku
   * Wybór wielu opcji
   * @example ["Wolnostojący"]
   */
  buildingType?: HouseBuildingTypeEnum[];
  /**
   * Liczba pieter od
   * Pojedynczy wybór
   * @format int32
   * @example 0
   */
  floorFrom?: null;
  /**
   * Liczba pieter do
   * Pojedynczy wybór
   * @format int32
   * @example 2
   */
  floorTo?: null;
}

/**
 * Typ budynku
 * @example "Blok"
 */
export enum FlatBuildingTypeEnum {
  Blok = "Blok",
  Apartamentowiec = "Apartamentowiec",
  Kamienica = "Kamienica",
  Pozostale = "Pozostałe",
}

export interface FlatsFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od, Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do, Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  lowerOriginalPrice: boolean;
  unlockedAdvertisements: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Typ ogłoszeniodawcy
   * Wybór wielu opcji
   * @example ["Agencja"]
   */
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Liczba pokoi w mieszkaniu od
   * @format int32
   * @min 0
   * @example 1
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w mieszkaniu do
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Typ rynku nieruchomości
   * Wybór wielu opcji
   * @example ["Pierwotny"]
   */
  typeOfMarket?: TypeOfMarketEnum[];
  /**
   * Typ budynku
   * Wybór wielu opcji
   * @example ["Blok"]
   */
  buildingType?: FlatBuildingTypeEnum[];
  /**
   * Piętro na którym jest mieszkanie od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro na którym jest mieszkanie do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Piętra w budynku od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Piętra w budynku do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
}

export interface CustomPage {
  content?: object[];
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface PageableObject {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  sort?: SortObject;
  paged?: boolean;
  unpaged?: boolean;
}

export interface SortObject {
  sorted?: boolean;
  empty?: boolean;
  unsorted?: boolean;
}

export interface BlockageInfoDto {
  /**
   * Id oryginalnego ogłoszenia zablokowanego
   * Id oryginalnego ogłoszenia mogą się zmienić podczas działania aplikacji
   * @format int64
   * @example 1
   */
  originalAdvertisementId: number;
  module: Module;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
  /**
   * Data blokady
   * @format date-time
   */
  blockedDate: string;
  /**
   * Nazwa użytkownika blokującego ogłoszenie
   * @example "Jan Kowalski"
   */
  userName: string;
  /**
   * Czy blokada jest stała
   * @example true
   */
  permanentlyBlocked: boolean;
  /**
   * Czy jest ustawiona blokada
   * @example true
   */
  notificationStatus: boolean;
  myBlockage?: boolean;
}

/** Moja opinia */
export interface MyOpinion {
  /**
   * Id opinii
   * @format int64
   */
  id: number;
  /**
   * Data dodania
   * @format date-time
   */
  dateAdded: string;
  /**
   * Liczba gwiazdek
   * @format int32
   * @example 1
   */
  numberOfStars: number;
  /**
   * Opis opinii
   * @example "xyz"
   */
  content?: string | null;
}

export interface NoteDto {
  /**
   * Id notatki
   * @format int64
   * @example 1
   */
  noteId: number;
  /**
   * Treść notatki
   * @example "xyz"
   */
  content: string;
  /**
   * Data notatki
   * @format date-time
   */
  date: string;
  /**
   * Czy notatka pochodzi z oryginalnego ogłoszenia
   * @example true
   */
  originalNote: boolean;
  /**
   * Nazwa użytkownika
   * @example "Jan Kowalski"
   */
  userName?: string;
  /**
   * Czy użytkownik jest właścicielem notatki
   * @example true
   */
  noteOwner: boolean;
}

export interface ReactionDto {
  /** Like Status */
  likeStatus?: boolean;
  /** Unlike Status */
  unlikeStatus?: boolean;
  /** Viewed Status */
  viewedStatus?: boolean;
  /** Outdated Status */
  outdatedStatus?: boolean;
  /** Arranged Status */
  arrangedStatus?: boolean;
  /** Phone Status */
  phoneStatus?: boolean;
  /** Hide Status */
  hideStatus?: boolean;
  /** OpenedStatus */
  openedStatus?: boolean;
}

export interface RentPlotDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena aplikacji o nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Liczba komentarzy opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityOpinions: number;
  /**
   * Ocena społeczności o nieruchomości
   * @format double
   * @example 5
   */
  communityScore: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 200
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
}

export interface RentPlotDtoPage {
  content?: RentPlotDto[];
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
}

/** Status ogłoszenia */
export interface RentStatusDto {
  /**
   * Ogłoszenie jest nowo dodane
   * @example true
   */
  isNew: boolean;
  /**
   * Ogłoszenie zostało zmodyfikowane
   * @example true
   */
  isModification: boolean;
  /**
   * Ogłoszenie zostało podbite
   * @example true
   */
  isTossedUp: boolean;
}

export interface RentOtherDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena aplikacji o nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Liczba komentarzy opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityOpinions: number;
  /**
   * Ocena społeczności o nieruchomości
   * @format double
   * @example 5
   */
  communityScore: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 200
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
}

export interface RentOtherDtoPage {
  content?: RentOtherDto[];
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface RentHouseDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena aplikacji o nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Liczba komentarzy opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityOpinions: number;
  /**
   * Ocena społeczności o nieruchomości
   * @format double
   * @example 5
   */
  communityScore: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 200
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface RentHouseDtoPage {
  content?: RentHouseDto[];
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface RentFlatDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena aplikacji o nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Liczba komentarzy opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii użytkowników
   * @format int32
   * @example 5
   */
  numberOfCommunityOpinions: number;
  /**
   * Ocena społeczności o nieruchomości
   * @format double
   * @example 5
   */
  communityScore: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 200
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface RentFlatDtoPage {
  content?: RentFlatDto[];
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface MetaValueDto {
  /** Klucz */
  key: string;
  /** Wartość */
  value?: string;
}

export interface ModificationDateDto {
  /**
   * Data modyfikacji
   * @format date-time
   */
  date: string;
  modificationDetail?: ModificationDto[];
}

export interface ModificationDto {
  /** Zmodyfikowane pole */
  field: string;
  /** Nowa wartość modyfikacji */
  newValue?: string;
  /** Stara wartość modyfikacji */
  oldValue?: string;
}

export interface RaisesValueDto {
  /** @format date-time */
  date?: string;
}

export interface RentHashDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena wynajmu
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 1000
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  /**
   * Typ budynku
   * @example "Blok"
   */
  buildingType?: string;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface RentOpinionResult {
  /**
   * Lista opinii ogłoszenia
   * @example "    [
   *         {
   *             "opinionId": "f0a23a12-66c0-4617-80e0-4c05922fd483",
   *             "dateAdded": "2024-02-02T15:50:55",
   *             "content": "xyz",
   *             "numberOfStars": 5,
   *             "loggedUserOption": true
   *         },
   *         {
   *             "opinionId": "g1a43a55-42c0-4221-90e1-4H05922fd451",
   *             "dateAdded": "2024-02-02T15:55:55",
   *             "content": null,
   *             "numberOfStars": 2,
   *             "loggedUserOption": false
   *         },
   *     ]
   * "
   */
  opinions?: SingleRentOpinion[];
  /**
   * Ocena społeczności
   * @format double
   * @example 4.2
   */
  communityScore: number;
  /**
   * Precyzja oceny przez aplikację
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Ocena aplikacji
   * @format double
   * @example 2.5
   */
  score: number;
}

/**
 * Lista opinii ogłoszenia
 * @example "    [
 *         {
 *             "opinionId": "f0a23a12-66c0-4617-80e0-4c05922fd483",
 *             "dateAdded": "2024-02-02T15:50:55",
 *             "content": "xyz",
 *             "numberOfStars": 5,
 *             "loggedUserOption": true
 *         },
 *         {
 *             "opinionId": "g1a43a55-42c0-4221-90e1-4H05922fd451",
 *             "dateAdded": "2024-02-02T15:55:55",
 *             "content": null,
 *             "numberOfStars": 2,
 *             "loggedUserOption": false
 *         },
 *     ]
 * "
 */
export interface SingleRentOpinion {
  /**
   * Id opinii
   * @format int64
   * @example 1
   */
  opinionId: number;
  /**
   * Data dodania opini
   * @format date-time
   */
  dateAdded: string;
  /**
   * Opis opinii
   * @example "xyz"
   */
  content?: string | null;
  /**
   * Liczba gwiazdek
   * @format int32
   * @example 2
   */
  numberOfStars: number;
  /**
   * Status opinii
   * Wartość true kiedy ta opinia należy do aktualnie zalogowanego użytkownika
   * @example true
   */
  loggedUserOpinion: boolean;
}

export interface SavedFiltersDto {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  id?: number;
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  module?: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms?: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail?: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert?: boolean;
}

export interface DuplicatePlotDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 2003
   */
  rentPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
}

export interface DuplicateOtherDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 2003
   */
  rentPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
}

export interface DuplicateHouseDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 2003
   */
  rentPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface DuplicateFlatDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 2003
   */
  rentPrice?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface RentPlotDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena wynajmu
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 1000
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
}

export interface RentOtherDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena wynajmu
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 1000
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
}

export interface RentHouseDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena wynajmu
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 1000
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

export interface RentFlatDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena wynajmu
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena czynszu
   * @format double
   * @example 200
   */
  depositPrice?: number;
  /**
   * Cena kaucji
   * @format double
   * @example 1000
   */
  rentPrice?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: RentStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
}

/**
 * Typ budynku
 * Wybór wielu opcji
 * @example ["Garaże"]
 */
export enum OtherFilterDtoBuildingTypeEnum {
  GarazeHalePozostale = "Garaże, Hale, Pozostałe",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  v2 = {
    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Update
     * @summary Aktualizacja opinii użytkownika
     * @request PUT:/v2/rent-offer/opinion/update
     * @secure
     */
    update: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
      },
      data: string,
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/rent-offer/opinion/update`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name PlotsFilterDetail
     * @summary Edycja filtra działki
     * @request PUT:/v2/rent-offer/filter/edit/plot
     * @secure
     */
    plotsFilterDetail: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/edit/plot`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name OtherFilterDetail
     * @summary Edycja filtra pozostałych typów ogłoszeń
     * @request PUT:/v2/rent-offer/filter/edit/other
     * @secure
     */
    otherFilterDetail: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/edit/other`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name HousesFilterDetail
     * @summary Edycja filtra domu
     * @request PUT:/v2/rent-offer/filter/edit/house
     * @secure
     */
    housesFilterDetail: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/edit/house`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FlatsFilterDetail
     * @summary Edycja filtra mieszkania
     * @request PUT:/v2/rent-offer/filter/edit/flat
     * @secure
     */
    flatsFilterDetail: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/edit/flat`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Create
     * @summary Tworzenie nowej opinii
     * @request POST:/v2/rent-offer/opinion/create
     * @secure
     */
    create: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
      },
      data: string,
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/rent-offer/opinion/create`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter
     * @summary Dodanie filtra działki
     * @request POST:/v2/rent-offer/filter/add/plot
     * @secure
     */
    createNewFilter: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/add/plot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter1
     * @summary Dodanie filtra pozostałych typów ogłoszenia
     * @request POST:/v2/rent-offer/filter/add/other
     * @secure
     */
    createNewFilter1: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/add/other`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter2
     * @summary Dodanie filtra domu
     * @request POST:/v2/rent-offer/filter/add/house
     * @secure
     */
    createNewFilter2: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/add/house`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter3
     * @summary Dodanie filtra mieszkania
     * @request POST:/v2/rent-offer/filter/add/flat
     * @secure
     */
    createNewFilter3: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/add/flat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadPlotsExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami działek
     * @request POST:/v2/rent-offer/excel/plot
     * @secure
     */
    downloadPlotsExcel: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/excel/plot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadOtherExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami pozostałych typów nieruchomości
     * @request POST:/v2/rent-offer/excel/other
     * @secure
     */
    downloadOtherExcel: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/excel/other`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadHousesExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami domów
     * @request POST:/v2/rent-offer/excel/house
     * @secure
     */
    downloadHousesExcel: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/excel/house`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadFlatsExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami mieszkań
     * @request POST:/v2/rent-offer/excel/flat
     * @secure
     */
    downloadFlatsExcel: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/excel/flat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadPlotsAdvertisements
     * @summary Pobieranie ogłoszeń działek
     * @request POST:/v2/rent-offer/advertisement/plot
     * @secure
     */
    downloadPlotsAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: PlotsFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<RentPlotDtoPage, object>({
        path: `/v2/rent-offer/advertisement/plot`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadOtherAdvertisements
     * @summary Pobieranie ogłoszeń pozostałych
     * @request POST:/v2/rent-offer/advertisement/other
     * @secure
     */
    downloadOtherAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: OtherFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<RentOtherDtoPage, object>({
        path: `/v2/rent-offer/advertisement/other`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadHousesAdvertisements
     * @summary Pobieranie ogłoszeń domów
     * @request POST:/v2/rent-offer/advertisement/house
     * @secure
     */
    downloadHousesAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: HousesFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<RentHouseDtoPage, object>({
        path: `/v2/rent-offer/advertisement/house`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadFlatAdvertisements
     * @summary Pobieranie ogłoszeń mieszkań
     * @request POST:/v2/rent-offer/advertisement/flat
     * @secure
     */
    downloadFlatAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: FlatsFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<RentFlatDtoPage, object>({
        path: `/v2/rent-offer/advertisement/flat`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullHashAdvertisement
     * @summary Ogłoszenie mieszkań wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/rent-offer/single-advertisement/detail
     * @secure
     */
    fullHashAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentHashDto, object>({
        path: `/v2/rent-offer/single-advertisement/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name FindAllByRent
     * @summary Wyszukiwanie opinii ogłoszenia
     * @request GET:/v2/rent-offer/opinion/find
     * @secure
     */
    findAllByRent: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
        /**
         * Id ogłoszenia
         * @format int64
         */
        rentId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentOpinionResult, string>({
        path: `/v2/rent-offer/opinion/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami podobnych nieruchomości
     * @name GenerateSimilarFilter
     * @summary Generowanie filtru dla podobnych nieruchomości na podstawie ID ogłoszenia
     * @request GET:/v2/rent-offer/filter/similar/generate
     * @secure
     */
    generateSimilarFilter: (
      query: {
        /** @format int64 */
        advertisementId: number;
        module: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/similar/generate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FindUserFilters
     * @summary Lista wszystkich filtrów użytkownika
     * @request GET:/v2/rent-offer/filter/list
     * @secure
     */
    findUserFilters: (
      query?: {
        module?: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SavedFiltersDto[], object>({
        path: `/v2/rent-offer/filter/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name PlotsFilterDetail1
     * @summary Szczegóły filtra działki
     * @request GET:/v2/rent-offer/filter/detail/plot
     * @secure
     */
    plotsFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PlotsFilterDto, object>({
        path: `/v2/rent-offer/filter/detail/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name OtherFilterDetail1
     * @summary Szczegóły filtra pozostałych
     * @request GET:/v2/rent-offer/filter/detail/other
     * @secure
     */
    otherFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<OtherFilterDto, object>({
        path: `/v2/rent-offer/filter/detail/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name HouseFilterDetail
     * @summary Szczegóły filtra domu
     * @request GET:/v2/rent-offer/filter/detail/house
     * @secure
     */
    houseFilterDetail: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<HousesFilterDto, object>({
        path: `/v2/rent-offer/filter/detail/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FlatsFilterDetail1
     * @summary Szczegóły filtra mieszkań
     * @request GET:/v2/rent-offer/filter/detail/flat
     * @secure
     */
    flatsFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<FlatsFilterDto, object>({
        path: `/v2/rent-offer/filter/detail/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindPlotsDuplicate
     * @summary Wszystkie duplikaty działek
     * @request GET:/v2/rent-offer/duplicate/find/plot
     * @secure
     */
    findPlotsDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicatePlotDto, object>({
        path: `/v2/rent-offer/duplicate/find/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindOtherDuplicate
     * @summary Wszystkie duplikaty pozostałych
     * @request GET:/v2/rent-offer/duplicate/find/other
     * @secure
     */
    findOtherDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateOtherDto, object>({
        path: `/v2/rent-offer/duplicate/find/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindHousesDuplicate
     * @summary Wszystkie duplikaty domów
     * @request GET:/v2/rent-offer/duplicate/find/house
     * @secure
     */
    findHousesDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateHouseDto, object>({
        path: `/v2/rent-offer/duplicate/find/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindFlatsDuplicate
     * @summary Wszystkie duplikaty mieszkań
     * @request GET:/v2/rent-offer/duplicate/find/flat
     * @secure
     */
    findFlatsDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateFlatDto, object>({
        path: `/v2/rent-offer/duplicate/find/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullPlotAdvertisement
     * @summary Ogłoszenie działek wraz z wszystkimi danymi
     * @request GET:/v2/rent-offer/advertisement/detail/plot
     * @secure
     */
    fullPlotAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentPlotDetailDto, object>({
        path: `/v2/rent-offer/advertisement/detail/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullOtherAdvertisement
     * @summary Ogłoszenie pozostałych wraz z wszystkimi danymi
     * @request GET:/v2/rent-offer/advertisement/detail/other
     * @secure
     */
    fullOtherAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentOtherDetailDto, object>({
        path: `/v2/rent-offer/advertisement/detail/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullHouseAdvertisement
     * @summary Ogłoszenie domów wraz z wszystkimi danymi
     * @request GET:/v2/rent-offer/advertisement/detail/house
     * @secure
     */
    fullHouseAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentHouseDetailDto, object>({
        path: `/v2/rent-offer/advertisement/detail/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullFlatAdvertisement
     * @summary Ogłoszenie mieszkań wraz z wszystkimi danymi
     * @request GET:/v2/rent-offer/advertisement/detail/flat
     * @secure
     */
    fullFlatAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<RentFlatDetailDto, object>({
        path: `/v2/rent-offer/advertisement/detail/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Delete
     * @summary Usuwanie opinii użytkownika
     * @request DELETE:/v2/rent-offer/opinion/delete
     * @secure
     */
    delete: (
      query: {
        module: Module;
        /** @format int64 */
        opinionId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/rent-offer/opinion/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ID - filter id
     *
     * @tags Zarządzanie filtrami
     * @name DeleteFilter
     * @summary Usuwanie filtra
     * @request DELETE:/v2/rent-offer/filter/delete
     * @secure
     */
    deleteFilter: (
      query: {
        module: Module;
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/rent-offer/filter/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
